<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
/* 修改element-ui样式 */
.el-notification .el-icon-success {
    /*修改弹窗样式*/
    color: #2881fc;
    /*  opacity: 1!important;*/
}

.parsA {
    color: #6ffa4b;
}

.parsB {
    color: #1ff7ea;
}

.parsC {
    color: #d592f0;
}
.el-notification__icon {
    margin-top: 6px !important;
}
.el-notification.left {
    left: 5% !important;
    transform: translateY(0.5rem);
    /* opacity: 1!important;*/
}
.el-notification.right {
    right: 50% !important;
    transform: translateX(50%) translateY(3rem);
    /* opacity: 1!important;*/
}

.el-notification__title {
    color: #fff !important;
    font-size: 14px !important;
}

.el-notification {
    background: rgba(59,93,178,0.8) !important;
    padding: 10px 26px 10px 9px !important;
    width: 12% !important;
    transition: opacity 0.5s, transform 0.5s, left 0.5s, right 0.5s, top 0.5s,
        bottom 0.5s, -webkit-transform 0.5s !important;
    border: 1px solid #b4c9ff !important;
    border-radius: 2px !important;
}

.el-notification__content {
    text-overflow: -o-ellipsis-lastline !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    /* color: #fffc00 !important; */
}

.el-notification__closeBtn {
    /* 关闭按钮*/
    top: 10px !important;
    right: 9px !important;
    color: #fff !important;
}

.el-notification__closeBtn:hover {
    /*结束*/
    color: #2881fc !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue